import { KeyValue } from '@/main/models/common';
import { PreQuoteTypeTypes, PreQuoteTypeActionTypes } from './preQuoteTypeTypes';

export function getPreQuoteType(): PreQuoteTypeActionTypes {
  return {
    type: PreQuoteTypeTypes.GET_PRE_QUOTE_TYPE
  };
}

export function savePreQuoteType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): PreQuoteTypeActionTypes {
  return {
    type: PreQuoteTypeTypes.SAVE_PRE_QUOTE_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerPreQuoteType(): PreQuoteTypeActionTypes {
  return {
    type: PreQuoteTypeTypes.RESET_REDUCER_PRE_QUOTE_TYPE
  };
}
